import {Injectable} from '@angular/core'
import {HttpClient, HttpHeaders} from '@angular/common/http'
import {catchError, map, Observable, of} from 'rxjs'
import {environment} from "../../../../apps/frontend/src/environments/environment"
import {GroupModel, GroupRoleModel} from "../../../domain/src/lib/authorization.model"
import {LoginRequestModel, UserContactModel, UserDetailModel} from "../../../domain/src/lib/user.model"
import {AppLogger, LoggerService} from "./logger.service"


@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly logger: AppLogger


  constructor(
      private readonly loggerService: LoggerService,
      private readonly http: HttpClient,
  ) {
    this.logger = this.loggerService.create('UserService')
  }


  getUserByUserId(userId: number): Observable<UserDetailModel> {
    const url = `${environment.apiUrl}/users/${userId}?details=true`
    return this.http.get<UserDetailModel>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  getUserContacts(isActive?: boolean): Observable<UserContactModel[]> {
    const url = `${environment.apiUrl}/users/contacts?active=${isActive}`
    return this.http.get<UserContactModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  addUser(user: UserDetailModel): Observable<any> {
    const url = `${environment.apiUrl}/users`
    return this.http.post(url, user).pipe(
        map(value => {
          return value
        }),
    )
  }


  updateUser(user: UserDetailModel): Observable<number> {
    const url = `${environment.apiUrl}/users/${user.userId}`
    return this.http.put<number>(url, user).pipe(
        map(value => {
          return value
        }),
    )
  }


  /*
   updateUserGroups(userId: number, groupIds: number[]): Observable<number> {
   const url = `${environment.apiUrl}/users/${userId}/groups`
   const res = this.http.put<number>(url, groupIds).pipe(
   map(value => {
   return value
   }),
   )
   return res
   }
   */


  deleteUsersByIds(ids: number[]): Observable<any> {
    const url = `${environment.apiUrl}/users/${ids}`
    return this.http.delete(url).pipe(
        catchError(this.handleError('deleteUser')),
    )
  }


  getRoles(): Observable<any> {
    const url = `${environment.apiUrl}/users/roles`
    return this.http.get<GroupRoleModel>(url).pipe(
        map(roles => {
          return roles
        }),
    )
  }


  getRolesByUserId(id: number): Observable<GroupRoleModel[]> {
    const url = `${environment.apiUrl}/users/${id}/roles`
    return this.http.get<GroupRoleModel[]>(url).pipe(
        map(value => {
          return value
        }),
    )
  }


  getGroups(): Observable<GroupModel[]> {
    const url = `${environment.apiUrl}/users/groups`
    return this.http.get<GroupModel[]>(url).pipe(
        map(value => {
          return value
        }),
    )
  }


  getGroupsByUserId(id: number): Observable<GroupModel[]> {
    const url = `${environment.apiUrl}/users/${id}/groups`
    return this.http.get<GroupModel[]>(url).pipe(
        map(value => {
          return value
        }),
    )
  }


  login(request: LoginRequestModel) {
    const url = `${environment.apiUrl}/login`
    const headers = new HttpHeaders().set('X-Forwarded-For', globalThis.location.hostname)
    return this.http.post<UserDetailModel>(url, request, {headers}).pipe(
        map(value => {
          return value
        }),
    )
  }


  logout(userId: number) {
    const url = `${environment.apiUrl}/logout`
    return this.http.post<UserDetailModel>(url, userId).pipe(
        map(value => {
          return value
        }),
    )
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<boolean> => {
      // TODO: send the error to remote logging infrastructure
      this.logger.error(error) // log to console instead
      // TODO: better job of transforming error for user consumption
      this.logger.error('handleError', operation, ' failed:', error.message)
      // Let the app keep running by returning an empty result.
      return of(false)
    }
  }

}
